export const getMomentLocale = languageLocale => {
    let loc = languageLocale || "en";
    if (loc === 'en-gb' || loc === 'en') {
        loc = 'en-GB';
    }

    return loc;
}